module.exports = __webpack_public_path__ + "img/3d_jp.e34bdd8.jpg";